export default __webpack_public_path__ + "static/media/warning.4d004f5f.svg";